module.exports = __webpack_public_path__ + "static/media/PaymentSuccessLogo.184fc5de.svg";